(function() { module.exports = this["wp"]["compose"]; }());